import React from "react";
import { useEffect,useState } from "react";

const Dashboard = () => {
  const [user, setUser] = useState("");
  useEffect(() => {
    // Retrieve user details from local storage
    const userData = localStorage.getItem("user");
    
    if (userData) {
      setUser(JSON.parse(userData));
    }
  }, []);


  return (
    <div>
      <h1>
      {user.name} ,  Welcome To Two App News Portal 
      </h1>
      <h1>
      You Can Add, Update and Delete The News from here.
      </h1>
    </div>
  );
};

export default Dashboard;
